// extracted by mini-css-extract-plugin
export default {"Carrousel":"Carrousel_Carrousel__kit87","show":"Carrousel_show__wjJ6k"};